import WorkTimeEntries from '../Workday/WorkTimeEntries.js';

const UserDetailWorkday=({parentId,application,userData})=>{
    return(
        <WorkTimeEntries parentId={parentId} application={application} userData={userData} file={'UserDetailWorkday.js'}/>
    );
}

export default UserDetailWorkday;
